/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicationHistory from './medication-history';
import MedicationHistoryDetail from './medication-history-detail';
import MedicationHistoryUpdate from './medication-history-update';
import MedicationHistoryDeleteDialog from './medication-history-delete-dialog';

const MedicationHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicationHistory />} />
    <Route path="new" element={<MedicationHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<MedicationHistoryDetail />} />
      <Route path="edit" element={<MedicationHistoryUpdate />} />
      <Route path="delete" element={<MedicationHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicationHistoryRoutes;
